module.exports = __webpack_public_path__ + "static/media/baner_cscu_videos_training.3950c52d.jpg";